import { generateTrendContent } from './methods/generate-trend-content'
import { generateManualContent } from './methods/generate-manual-content'
import { regenerateContent } from './methods/regenerate-content'
import { cancelGeneration } from './methods/cancel-generation'
import { resetContent } from './methods/reset-content'
import { restorePreviousContent } from './methods/restore-previous-content'

/**
 * Content service provides methods for working with content generation
 */
export const contentService = {
  generateTrendContent,
  generateManualContent,
  regenerateContent,
  cancelGeneration,
  resetContent,
  restorePreviousContent,
}

export {
  generateTrendContent,
  generateManualContent,
  regenerateContent,
  cancelGeneration,
  resetContent,
  restorePreviousContent,
}
